"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayLoadContentType = void 0;
exports.PayLoadContentTypeFromJSON = PayLoadContentTypeFromJSON;
exports.PayLoadContentTypeFromJSONTyped = PayLoadContentTypeFromJSONTyped;
exports.PayLoadContentTypeToJSON = PayLoadContentTypeToJSON;
exports.PayLoadContentTypeToJSONTyped = PayLoadContentTypeToJSONTyped;
/**
 * ContentType for PayLoad
 * @export
 * @enum {string}
 */
var PayLoadContentType;
(function (PayLoadContentType) {
    PayLoadContentType["News"] = "news";
    PayLoadContentType["Celeb"] = "celeb";
    PayLoadContentType["Gallery"] = "gallery";
    PayLoadContentType["Longvideo"] = "longvideo";
    PayLoadContentType["Promo"] = "promo";
    PayLoadContentType["Character"] = "character";
})(PayLoadContentType || (exports.PayLoadContentType = PayLoadContentType = {}));
function PayLoadContentTypeFromJSON(json) {
    return PayLoadContentTypeFromJSONTyped(json, false);
}
function PayLoadContentTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PayLoadContentTypeToJSON(value) {
    return PayLoadContentTypeToJSONTyped(value, false);
}
function PayLoadContentTypeToJSONTyped(value, ignoreDiscriminator = false) {
    return value;
}
